import { animalStore, syncQueue } from '../../offline/indexedDBService'
import { v4 as uuidv4 } from 'uuid'
import AxiosControl from '../../components/axios/AxiosControl'
const Axios = AxiosControl()

export const getAnimals = (page, limit, search) => async (dispatch) => {
    dispatch({ type: 'ANIMAL_LOADING' })
    try {
        const { data, status } = await Axios.post('/api/animal/getall/', { page, limit, search }, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'ANIMAL_GETALL_SUCCESS',
                payload: data
            })
        } else {
            dispatch({ type: 'ANIMAL_NOT_LOADING' })
        }
    } catch (error) {
        dispatch({ type: 'ANIMAL_NOT_LOADING' })
    }
}

export const getForSelect = () => async (dispatch) => {
    dispatch({ type: 'ANIMAL_LOADING' })
    try {
        const { data, status } = await Axios.get('/api/animal/getforselect/', {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'ANIMAL_GETALLFORSELECT_SUCCESS',
                payload: data
            })
        } else {
            dispatch({ type: 'ANIMAL_NOT_LOADING' })
        }
    } catch (error) {
        dispatch({ type: 'ANIMAL_NOT_LOADING' })
    }
}

export const getReviewMarkForSelect = () => async (dispatch) => {
    dispatch({ type: 'ANIMAL_LOADING' })
    try {
        const { data, status } = await Axios.get('/api/animal/getreviewmarkforselect/', {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'ANIMAL_GETALLFORSELECT_SUCCESS',
                payload: data
            })
        } else {
            dispatch({ type: 'ANIMAL_NOT_LOADING' })
        }
    } catch (error) {
        dispatch({ type: 'ANIMAL_NOT_LOADING' })
    }
}

export const getAnimal = (animal) => async (dispatch) => {
    dispatch({ type: 'ANIMAL_LOADING' })
    try {
        const { data, status } = await Axios.get('/api/animal/get/' + animal, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'ANIMAL_GET_SUCCESS',
                payload: data
            })
        } else {
            dispatch({ type: 'ANIMAL_NOT_LOADING' })
        }
    } catch (error) {
        dispatch({ type: 'ANIMAL_NOT_LOADING' })
    }
}

export const addAnimal = (animaldata) => async (dispatch, getState) => {
	const tempId = uuidv4()
	const { lotsForSelect } = getState().lots

	if (!navigator.onLine) {
		await animalStore.setItem(tempId, animaldata)
		await syncQueue.setItem(tempId, {
			type: 'ANIMAL_ADD_OFFLINE',
			payload: animaldata
		})
		dispatch({
			type: 'ANIMAL_ADD_SUCCESS',
			payload: {
				animal: { ...animaldata, _id: tempId, id: tempId, offline: true,
					lot: lotsForSelect.find(lot => lot._id === animaldata.lot) || {
						_id: animaldata.lot,
						identifier: animaldata.lot
					}
				},
				message: 'success'
			}
		})
		return
	}

	try {
		const { data, status } = await Axios.post('/api/animal/register', animaldata, {
			headers: { auth: localStorage.getItem('jwt') }
		})
		if (status === 200) {
			dispatch({
				type: 'ANIMAL_ADD_SUCCESS',
				payload: data
			})
		} else if (status === 264 || status === 260) {
			dispatch({
				type: 'ANIMAL_WRONG_SUCCESS',
				payload: data
			})
		} else {
			dispatch({ type: 'ANIMAL_NOT_LOADING' })
		}
	} catch (error) {
		dispatch({ type: 'ANIMAL_NOT_LOADING' })
	}
}

export const editAnimal = (animaldata, animalId) => async (dispatch, getState) => {
	const { lotsForSelect } = getState().lots

    if (!navigator.onLine) {
        await animalStore.setItem(animalId, animaldata)
        await syncQueue.setItem(animalId, {
            type: 'ANIMAL_EDIT_OFFLINE',
            id: animalId,
            payload: animaldata
        })

        dispatch({
            type: 'ANIMAL_EDIT_SUCCESS',
            payload: {
                animal: {
                    ...animaldata,
                    _id: animalId,
                    offline: true,
					lot: lotsForSelect.find(lot => lot._id === animaldata.lot) || {
						_id: animaldata.lot,
						identifier: animaldata.lot
					}
                },
				message: 'editSuccess'
            }
        })
        return
    }

    try {
        const { data, status } = await Axios.put('/api/animal/edit/' + animalId, animaldata, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200 || status === 264) {
            dispatch({
                type: 'ANIMAL_EDIT_SUCCESS',
                payload: data
            })
        }
    } catch (error) {
        dispatch({ type: 'ANIMAL_NOT_LOADING' })
    }
}